import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["disabled", "data-test"]
const _hoisted_2 = {
  key: 0,
  class: "tw-flex tw-absolute"
}

import CoreSpinner from 'frontcore/views/loaders/spinner/CoreSpinner.vue'
import SVGIcon from 'frontcore/views/icons/SVGIcon.vue'
import { computed } from 'vue'
import { SpinnerSize } from 'frontcore/views/loaders/spinner/types'


export default /*@__PURE__*/_defineComponent({
  __name: 'CoreButton',
  props: {
  buttonType: {
    type: String,
    default: 'primary',
    validator: (value: string) => {
      const availableTypes = [
        'primary',
        'secondary',
        'ghost',
        'destructive-primary',
        'destructive-ghost',
      ]
      return availableTypes.includes(value)
    },
  },
  dataTest: String,
  disabled: Boolean,
  iconName: String,
  label: {
    type: String,
    default: '',
  },
  loading: {
    type: Boolean,
    default: false,
  },
},
  emits: ["click"],
  setup(__props, { emit: __emit }) {

const props = __props

const modeDisabled = computed(() => {
  return props.disabled || props.loading
})

const iconColor = computed(() => {
  switch (props.buttonType) {
  case 'primary':
  case 'destructive-primary':
    return 'tw-fill-core-neutral-cold-100'
  case 'destructive-ghost':
    return props.disabled && !props.loading ? 'tw-fill-core-neutral-cold-60' : 'tw-fill-auxiliary-error-30'
  default:
    return props.disabled && !props.loading ? 'tw-fill-core-neutral-cold-50' : 'tw-fill-core-primary-30'
  }
})

const paddingClass = computed(() => {
  if (props.label && props.iconName) {
    return 'mlui-button--icon-and-label'
  } else if (props.label && !props.iconName) {
    return 'mlui-button--only-label'
  } else if (!props.label && props.iconName) {
    return 'mlui-button--only-icon'
  }
  return ''
})

const spinnerColor = computed(() => {
  switch (props.buttonType) {
  case 'destructive-primary':
  case 'destructive-ghost':
    return 'auxiliary-error-30'
  default:
    return 'core-primary-20'
  }
})

const emit = __emit

const clickButton = () => {
  if (!modeDisabled.value) {
    emit('click')
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(["mlui-button buttons--button-01", [
      'tw-flex tw-justify-center tw-items-center tw-min-w-0 gap-1 tw-h-10',
      'tw-rounded',
      `mlui-button--${__props.buttonType}`,
      paddingClass.value,
      {'tw-cursor-not-allowed': modeDisabled.value},
      {'loading-spinner': __props.loading},
    ]]),
    disabled: modeDisabled.value,
    "data-test": __props.dataTest,
    type: "button",
    onClick: _withModifiers(clickButton, ["stop"])
  }, [
    (__props.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(CoreSpinner, {
            size: _unref(SpinnerSize).SMALL,
            colorCssVar: spinnerColor.value
          }, null, 8, ["size", "colorCssVar"])
        ]))
      : _createCommentVNode("", true),
    (__props.iconName)
      ? (_openBlock(), _createBlock(SVGIcon, {
          key: 1,
          class: _normalizeClass([
        {'tw-opacity-20': __props.loading}
      ]),
          colorClass: iconColor.value,
          iconName: __props.iconName,
          remSize: 1.25
        }, null, 8, ["class", "colorClass", "iconName"]))
      : _createCommentVNode("", true),
    (__props.label)
      ? (_openBlock(), _createElementBlock("span", {
          key: 2,
          class: _normalizeClass([
        'label tw-truncate',
        {'tw-opacity-20': __props.loading}
      ])
        }, _toDisplayString(__props.label), 3))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})